import { render, staticRenderFns } from "./LaundryPushNotification.vue?vue&type=template&id=159ac218&scoped=true"
import script from "./LaundryPushNotification.vue?vue&type=script&lang=js"
export * from "./LaundryPushNotification.vue?vue&type=script&lang=js"
import style0 from "./LaundryPushNotification.vue?vue&type=style&index=0&id=159ac218&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "159ac218",
  null
  
)

export default component.exports